import Loader from 'components/Loader';
import ToggleButton from 'components/ToggleButton';
import { useFormik } from 'formik';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { toast } from 'react-toastify';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
} from 'reactstrap';
import { createStructuredSelector } from 'reselect';
import { api } from 'utils/axios';
import {
  API_BASE_URL,
  EMAIL_REGEX,
  LATITUDE_REGEX,
  LONGITUDE_REGEX,
  PHONE_REGEX,
  SCHOOL_GENDER_VALUES,
  SchoolMasterType,
  SchoolShifts,
  WEBSITE_REGEX,
} from 'utils/constants';
import { titleCaseIfExists } from 'utils/helper';
import { SMKLinks } from 'utils/links';
import * as Yup from 'yup';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import useRequest from '../../../hooks/useRequest';
import {
  getCities,
  getCountries,
  getRegions,
  getSchoolBoards,
  getSchoolLevels,
  getSchoolsGroups,
  getSchoolsMasterData,
  getSubAreas,
} from '../actions';
import {
  citiesSelector,
  countriesSelector,
  regionsSelector,
  selectSchoolBoards,
  selectSchoolLevels,
  selectSchoolsGroups,
  selectSchoolsMasterData,
  subAreasSelector,
} from '../selectors';
import staticCitiesList from './components/cities.json';
import { DEAFULT_CITY, DEAFULT_REGION, getSchoolLevelsList, romanToInt } from './components/constants';
import staticGradesList from './components/grades.json';
import schoolsListData from './components/schools.json';

const stateSelector = createStructuredSelector({
  countries: countriesSelector,
  regions: regionsSelector,
  cities: citiesSelector,
  subAreas: subAreasSelector,
  schoolsMasterData: selectSchoolsMasterData,
  schoolLevelsList: selectSchoolLevels,
  schoolBoards: selectSchoolBoards,
  schoolsGroups: selectSchoolsGroups,
});

const AddSchoolTemp = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { countries, regions, cities, subAreas, schoolsMasterData, schoolLevelsList, schoolBoards } = useSelector(
    stateSelector
  );
  toast.configure();

  const [selectedSchoolData, setSelectedSchoolData] = useState(null);
  const [selectedSchoolDataObj, setSelectedSchoolDataObj] = useState(null);
  const [loading, setLoading] = useState(false);

  const studentGenderList = Object.entries(SCHOOL_GENDER_VALUES).map(([key, value]) => ({
    value,
    label: titleCaseIfExists(key),
  }));

  const [gradeError, setGradeError] = useState();

  const [schoolDetails, setSchoolDetails] = useState(null);

  const [addSchoolRequest, { loading: addSchoolLoading }] = useRequest({
    url: `/school/admin`,
    method: 'POST',
    onSuccess: (data) => {
      setSchoolDetails(data);
    },
    onError: (err) => {
      toast.error(err?.message || err);
    },
  });

  const isEmptyValue = (val) => {
    return val || undefined;
  };

  const getInitialValues = () => ({
    name: '',
    shortName: '',

    country: {},
    region: {},
    district: {},
    city: {},
    subArea: {},

    postalCode: '',
    fullAddress: '',
    latitude: '',
    longitude: '',

    establishedIn: '',
    studentGender: {},

    managementType: {},
    managementName: '',

    boardingType: {},
    boardingSubTypes: [],
    boardingGenderType: {},

    curriculumBoards: [],

    lowestgrade: {},
    highestgrade: {},

    schoolShift: [],

    phoneMobile: '',
    phoneLandline: '',
    emailInfo: '',
    emailAdmission: '',

    academicYear: '',
    admissionPeriod: '',
  });

  const addObjectsInArray = ({ field1, value1, field2, value2, type }) => {
    const finalArr = [];
    if (isEmpty(value1) && isEmpty(value2)) {
      return undefined;
    }
    if (!isEmpty(value1)) {
      if (type === 'numbers') {
        finalArr?.push({
          type: field1,
          number: value1,
        });
      } else {
        finalArr?.push({
          type: field1,
          email: value1,
        });
      }
    }
    if (!isEmpty(value2)) {
      if (type === 'numbers') {
        finalArr?.push({
          type: field2,
          number: value2,
        });
      } else {
        finalArr?.push({
          type: field2,
          email: value2,
        });
      }
    }

    return finalArr;
  };

  const checkArrUndefined = (arr) => {
    return arr.every((element) => element === undefined);
  };

  const formik = useFormik({
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: getInitialValues(),
    onSubmit: (values) => {
      if (isEmpty(gradeError)) {
        let masterData = [values.managementType, values.boardingType];
        if (values.boardingType.name.includes('Boarding')) {
          masterData = [...masterData, ...values.boardingSubTypes, values.boardingGenderType];
        }

        const academicInfoData = {
          shift: isEmpty(values?.schoolShift) ? undefined : values.schoolShift,
        };

        const admissionInfoData = {
          academicYear: isEmptyValue(values.academicYear),
          admissionPeriod: !isEmpty(values.admissionPeriod)
            ? [
                {
                  board: 'All',
                  level: 'All',
                  period: isEmptyValue(values.admissionPeriod),
                },
              ]
            : undefined,
        };

        const basicInfoData = {
          establishedIn: isEmptyValue(values.establishedIn),
          managementName: isEmptyValue(values.managementName),

          phoneNumbers: addObjectsInArray({
            field1: 'mobile',
            value1: values?.phoneMobile,
            field2: 'landline',
            value2: values?.phoneLandline,
            type: 'numbers',
          }),
          emails: addObjectsInArray({
            field1: 'info',
            value1: values?.emailInfo,
            field2: 'admissions',
            value2: values?.emailAdmission,
            type: 'email',
          }),
          website: values.website,
        };

        const academicInfoDataValues = Object.values(academicInfoData);
        const admissionInfoDataValues = Object.values(admissionInfoData);
        const basicInfoDataValues = Object.values(basicInfoData);

        addSchoolRequest({
          body: {
            active: false,
            name: values?.name ? values?.name : '',
            shortName: values?.shortName ? values?.shortName : '',
            studentGender: values.studentGender.value,
            boards: values.curriculumBoards ? values.curriculumBoards : null,
            lowestGrade: values.lowestgrade?.label ? values.lowestgrade?.label : '',
            highestGrade: values.highestgrade?.label ? values.highestgrade?.label : '',
            address: {
              country: {
                id: values.country.id ? values.country.id : null,
                name: values.country.name ? values.country.name : null,
                slug: values.country.slug ? values.country.slug : null,
              },
              region: {
                id: values.region.id ? values.region.id : null,
                name: values.region.name ? values.region.name : null,
                slug: values.region.slug ? values.region.slug : null,
              },
              city: {
                id: values.city.id ? values.city.id : null,
                name: values.city.name ? values.city.name : null,
                slug: values.city.slug ? values.city.slug : null,
              },
              district: {
                id: values.district.id ? values.district.id : null,
                name: values.district.name ? values.district.name : null,
                slug: values.district.slug ? values.district.slug : null,
              },
              subArea: {
                id: values.subArea.id ? values.subArea.id : null,
                name: values.subArea.name ? values.subArea.name : null,
                slug: values.subArea.slug ? values.subArea.slug : null,
              },
              postalCode: values.postalCode ? values?.postalCode : '',
              fullAddress: values.fullAddress ? values?.fullAddress : '',
              location: {
                latitude: Number(String(values?.latitude).slice(0, 11)) || 0,
                longitude: Number(String(values?.longitude).slice(0, 11)) || 0,
              },
            },
            academicInfo: checkArrUndefined(academicInfoDataValues) ? undefined : academicInfoData,
            admissionInfo: checkArrUndefined(admissionInfoDataValues) ? undefined : admissionInfoData,
            basicInfo: checkArrUndefined(basicInfoDataValues) ? undefined : basicInfoData,
            masterData,
          },
        });
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('School Name is required'),
      country: Yup.object().test('countryTest', 'Please select a country', (val) => !isEmpty(val)),
      region: Yup.object().test('regionTest', 'Please select a region', (val) => !isEmpty(val)),
      city: Yup.object().test('cityTest', 'Please select a city', (val) => !isEmpty(val)),
      // establishedIn: Yup.date('Established year is required'),
      studentGender: Yup.object().test(
        'studentGenderTest',
        'Please select student gender type',
        (val) => !isEmpty(val)
      ),
      managementType: Yup.object().test('managTest', 'Please select management type', (val) => !isEmpty(val)),
      // managementName: Yup.string().required('Mangement name is required'),
      boardingType: Yup.object().test('boardingTest', 'Please select boarding type', (val) => !isEmpty(val)),
      boardingSubTypes: Yup.array().when('boardingType', {
        is: (val) => !isEmpty(val) && [val.name].includes('Boarding'),
        then: Yup.array().required('boardingSubTypeTest', 'Please select an boarding subtype ', (val) => !isEmpty(val)),
      }),
      boardingGenderType: Yup.object().when('boardingType', {
        is: (val) => !isEmpty(val) && [val.name].includes('Boarding'),
        then: Yup.object().test('boardingGenderTest', 'Please select an boarding gender ', (val) => !isEmpty(val)),
      }),
      curriculumBoards: Yup.array().test(
        'curriculumBoardsTest',
        'Please select curriculum boards',
        (val) => !isEmpty(val)
      ),
      lowestgrade: Yup.object().test('lowestgradeTest', 'Please select lowest grade', (val) => !isEmpty(val)),
      highestgrade: Yup.object().test('highestgradeTest', 'Please select highest grade', (val) => !isEmpty(val)),
      emailInfo: Yup.string().matches(EMAIL_REGEX, 'Please provide valid email'),
      emailAdmission: Yup.string().matches(EMAIL_REGEX, 'Please provide valid email'),
      phoneMobile: Yup.string().matches(PHONE_REGEX, 'Please provide valid number'),
      phoneLandline: Yup.string().matches(PHONE_REGEX, 'Please provide valid number'),
      website: Yup.string().matches(
        WEBSITE_REGEX,
        'Please enter a valid URL with a valid domain (e.g. .com, .org, .edu)'
      ),
      latitude: Yup.string().matches(LATITUDE_REGEX, 'Please enter correct format'),
      longitude: Yup.string().matches(LONGITUDE_REGEX, 'Please enter correct format'),
    }),
  });

  useEffect(() => {
    dispatch(getCountries.trigger({ level: 0, page: 1, size: 500, sortBy: 'slug', sortOrder: 0 }));
    dispatch(getSchoolsMasterData.trigger());
    dispatch(getSchoolBoards.trigger());
    dispatch(
      getSchoolsGroups.trigger({
        page: 1,
        size: 500,
        sortBy: 'id',
        sortOrder: 0,
      })
    );
  }, []);

  const handleCountrySelect = (country) => {
    if (!isEmpty(country)) {
      dispatch(
        getRegions.trigger({
          level: 1,
          country: country.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );
      dispatch(
        getSchoolLevels.trigger({
          country: country?.name || '',
        })
      );

      formik.setFieldValue('country', country);
    } else {
      formik.setFieldValue('country', {});
    }

    formik.setFieldValue('region', {});
    formik.setFieldValue('city', {});
    formik.setFieldValue('subArea', {});
    formik.setFieldValue('postalCode', '');
  };

  const handleRegionSelect = (region) => {
    if (!isEmpty(region)) {
      dispatch(
        getCities.trigger({
          level: 3,
          cityOnly: false,
          region: region.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );

      formik.setFieldValue('region', region);
    } else {
      formik.setFieldValue('region', {});
    }

    formik.setFieldValue('district', {});
    formik.setFieldValue('city', {});
    formik.setFieldValue('subArea', {});
    formik.setFieldValue('postalCode', '');
  };

  const handleDistrictSelect = (district) => {
    if (!isEmpty(district)) {
      dispatch(
        getSubAreas.trigger({
          level: 4,
          city: district.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );

      formik.setFieldValue('district', district);
    } else {
      formik.setFieldValue('district', {});
    }

    formik.setFieldValue('city', {});
    formik.setFieldValue('subArea', {});
    formik.setFieldValue('postalCode', '');
  };

  const handleCitySelect = (city) => {
    if (!isEmpty(city)) {
      if (!city.id && !city.name) {
        city.name = city.label;
      }
      dispatch(
        getSubAreas.trigger({
          level: 4,
          city: city.name,
          page: 1,
          size: 500,
          sortBy: 'slug',
          sortOrder: 0,
        })
      );
      formik.setFieldValue('city', city);
    } else {
      formik.setFieldValue('city', {});
    }

    formik.setFieldValue('subArea', {});
    formik.setFieldValue('postalCode', '');
  };

  const handleSubAreaSelect = (subArea) => {
    if (!isEmpty(subArea)) {
      if (!subArea.id && !subArea.name) {
        subArea.name = subArea.label;
      }
      formik.setFieldValue('subArea', subArea);
    } else {
      formik.setFieldValue('subArea', {});
    }

    formik.setFieldValue('postalCode', '');
  };

  const handleToggleShifts = (checked, shift) => {
    let array = formik.values.schoolShift?.slice();
    if (checked) {
      array = [...array, shift];
    } else {
      array = array.filter((s) => s.name.toLowerCase() !== shift.name.toLowerCase());
    }
    formik.setFieldValue('schoolShift', array);
  };

  const gradeSelectFunc = (data) => {
    const classesArr = [];
    data
      .slice()
      .sort((a, b) => a.level - b.level)
      ?.map((e) => e?.classes?.map((c) => classesArr?.push(c)));

    const unique2 = classesArr.filter((obj, index) => {
      return index === classesArr.findIndex((o) => obj.level === o.level && obj.name === o.name);
    });

    return unique2?.sort((a, b) => a?.level - b?.level);
  };

  const gradeSelectArray = gradeSelectFunc(schoolLevelsList);

  const schoolBoardsSelect = schoolBoards
    ?.filter((d) => !d.preschool)
    ?.sort((a, b) => {
      if (a.slug < b.slug) {
        return -1;
      }
      if (a.slug > b.slug) {
        return 1;
      }
      return 0;
    });

  useEffect(() => {
    if (!isEmpty(formik.values.highestgrade)) {
      formik?.values?.lowestgrade?.level > formik?.values?.highestgrade?.level
        ? setGradeError('Please select a grade higher than the lowest')
        : setGradeError('');
    }
  }, [formik.values.highestgrade]);

  // ======================================================== Upload JSON ========================================================

  const filterSchoolGrade = (rangeStr) => {
    if (!rangeStr || typeof rangeStr !== 'string') return null;

    const parts = rangeStr.split('to').map((part) => part.trim());

    if (parts.length !== 2) return null;

    const lowGrade = parts[0].replaceAll('.', '').toLowerCase();

    return {
      lowestgrade: lowGrade === 'nur' ? 'Nursery' : lowGrade,
      highestgrade: parts[1].toUpperCase(),
    };
  };

  const handleFileUpload = async (event, isFile) => {
    const file = isFile ? event : event.target.files[0];
    if (!file) return;

    // Checking file extension
    const validExtension = file.name.endsWith('.json');
    const validMimeType = file.type === 'application/json';

    if (!validExtension || !validMimeType) {
      alert('Please upload a valid .json file.');
      return;
    }

    const managementTypes = schoolsMasterData.filter((d) => d.type === SchoolMasterType.MANAGEMENT_TYPE);
    const boardingTypes = schoolsMasterData.filter((d) => d.type === SchoolMasterType.BOARDING_TYPE);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const obj = JSON.parse(e.target.result);
        const schoolListObj = schoolsListData?.schools?.find(
          (e) => e?.['School ID'] === obj?.['schoolInfo']['School Id']
        );

        setSelectedSchoolData(obj);
        setSelectedSchoolDataObj(schoolListObj);
        //  Established Year
        let establishedInDate = '';
        if (obj?.['schoolInfo']?.['Year Of Estd.']) {
          establishedInDate = new Date(obj?.['schoolInfo']?.['Year Of Estd.'], 0, 1);
        }

        // Country
        const country = countries?.find((e) => e?.displayName?.toLowerCase() === 'india');
        handleCountrySelect(country);

        const district = staticCitiesList?.find(
          (e) => e?.displayName?.toLowerCase() === `${schoolListObj?.District?.toLowerCase()} delhi`
        );

        const schoolGrades = filterSchoolGrade(obj?.['schoolInfo']['Nomenclature']);
        const lowestgrade = staticGradesList?.find(
          (e) => e?.label?.toLowerCase() === schoolGrades?.lowestgrade?.toLowerCase()
        );
        const highestgrade = staticGradesList?.find(
          (e) => e?.label?.toUpperCase() === schoolGrades?.highestgrade?.toUpperCase()
        );

        const payload = {
          shortName: '',
          name: obj?.['schoolInfo']['School Name'],
          establishedIn: establishedInDate,
          fullAddress: obj?.['schoolInfo']['Address'],
          studentGender: !isEmpty(obj?.['schoolInfo']['Gender'])
            ? studentGenderList?.find((e) => e?.label.toLowerCase() === obj?.['schoolInfo']['Gender']?.toLowerCase())
            : {},

          phoneLandline: '',
          phoneMobile: !isEmpty(obj?.['schoolInfo']['School Phone'])
            ? '9111' + obj?.['schoolInfo']['School Phone']
            : '',
          emailInfo: obj?.['schoolInfo']['School Email']?.replaceAll('[at]', '@')?.replaceAll('[dot]', '.'),
          emailAdmission: '',

          academicYear: 'April to March',
          admissionPeriod: 'November onwards',

          country,
          district,
          region: DEAFULT_REGION,
          city: DEAFULT_CITY,
          subArea: {},

          postalCode: '',
          latitude: schoolListObj?.['Latitude'] || '',
          longitude: schoolListObj?.['Longitude'] || '',

          managementType: managementTypes?.find((e) => e?.name === 'State Government School'),
          managementName: 'Delhi Directorate of Education',

          boardingType: boardingTypes[0],
          boardingSubTypes: [],
          boardingGenderType: {},

          curriculumBoards: schoolBoardsSelect?.filter((e) => e?.slug === 'cbse') || [],

          lowestgrade,
          highestgrade,

          schoolShift:
            obj?.['schoolInfo']?.['Shift']?.toLowerCase() === 'evening'
              ? SchoolShifts
              : SchoolShifts.filter((s) => s?.name === 'Shift 1 (Morning)'),
        };

        if (isFile) {
          formik.setValues(payload);
          formik.handleSubmit();
        } else {
          formik.setValues(payload);
        }
      } catch (err) {
        console.warn('Error', err);
        alert('Invalid JSON file');
      }
    };
    reader.readAsText(file);
  };

  const handleUpdateSchoolDetails = async (data) => {
    setLoading(true);
    // =============== Basic Info ===============
    const basicInfoPayload = {
      schoolId: data?.id,
      name: selectedSchoolDataObj?.school_name || data?.name,
      studentGender: data?.studentGender,
      shortName: '',
      preschool: false,
      images: [],
      admissionInfo: {},
      basicInfo: {
        establishedIn: data?.establishedIn,
        managementName: data?.managementName,
        management: [
          {
            email: selectedSchoolData?.['schoolInfo']['EmailId of HOS']
              ?.replaceAll('[at]', '@')
              ?.replaceAll('[dot]', '.'),
            name: selectedSchoolData?.['schoolInfo']['Name of HOS']?.replace('(PRINCIPAL)', ''),
            phone: !isEmpty(selectedSchoolData?.['schoolInfo']['Contact No. of HOS']?.replaceAll('Not Available', ''))
              ? '9111' + selectedSchoolData?.['schoolInfo']['Contact No. of HOS']?.replaceAll('Not Available', '')
              : '',
            type: 'Principal',
          },
          {
            email: '',
            name: '',
            phone: '',
            type: 'Chairman',
          },
          {
            email: '',
            name: '',
            phone: '',
            type: 'Chairperson',
          },
        ],
        socialProfiles: [
          {
            type: 'twitter',
            handle: '',
          },
          {
            type: 'facebook',
            handle: '',
          },
        ],
        schoolMotto: '',
        officeHours: '',
        managementCommittee: '',
        about: '',
      },
      masterData: [
        {
          id: 27,
          version: 1,
          deleted: false,
          active: true,
          name: 'State Government School',
          displayName: null,
          type: 2,
          description: null,
          value: 27,
          label: 'State Government School',
        },
        {
          id: 1,
          version: 1,
          deleted: false,
          active: true,
          name: 'Day School',
          displayName: null,
          type: 0,
          description: null,
          value: 1,
          label: 'Day School',
        },
      ],
      schoolGroups: [
        {
          id: 14,
          version: 1,
          deleted: false,
          active: true,
          name: 'Delhi Government Schools',
          shortName: 'delgov',
          slug: 'delhi-government-schools',
          description: null,
          logoId: null,
          website: null,
          isAssociation: false,
          addToSitemap: true,
          logo: null,
          value: 14,
          label: 'Delhi Government Schools',
        },
      ],
    };

    const basicInfoResponse = await api({
      method: 'POST',
      url: `${API_BASE_URL}/school/admin/edit/updateBasicInfo`,
      data: basicInfoPayload,
    });

    // =============== Additional Info ===============
    const resultDetails = !isEmpty(selectedSchoolData?.['examinationDetails'])
      ? `
      <table border="1" cellpadding="8" cellspacing="0">
        <thead>
          <tr>
            <th>Year</th>
            <th>Class 10</th>
            <th>Class 12</th>
          </tr>
        </thead>
        <tbody>
          ${selectedSchoolData['examinationDetails']
            .map(
              (item) => `
                <tr>
                  <td>${item?.year || ''}</td>
                  <td>${item?.xth || ''}</td>
                  <td>${item?.xiith || ''}</td>
                </tr>
              `
            )
            .join('')}
        </tbody>
      </table>
    `
      : '';

    const additionalInfoPayload = {
      schoolId: data?.id,
      additionalInfo: {
        ranking: [],
        campusSize: selectedSchoolData?.['Building Details']?.['Total Land Area(Sqm)']?.replace('Not Available', ''),
        studentCount: selectedSchoolData?.attendanceDetails?.totalStudents,
        teacherCount: selectedSchoolData?.attendanceDetails?.totalTeachers,
        relatedSchools: [],
        schoolHolidays: [],
        awards: '',
        resultDetails,
        alumni: '',
        staffDetails: '',
      },
      academicInfo: {
        resultDetails,
      },
    };
    const additionalInfoResponse = await api({
      method: 'POST',
      url: `${API_BASE_URL}/school/admin/edit/updateAdditionalInfo`,
      data: additionalInfoPayload,
    });

    // =============== Facility Details ===============
    const facilitySections = ['Toilet Details', 'Urinals Details', 'Water Facility Details'];

    const facilityDetails = facilitySections
      .filter((section) => !isEmpty(selectedSchoolData?.[section]))
      .map((section) => {
        const items = selectedSchoolData[section];
        return `
          <div>
              <h4>${section}</h4>
              <ul>
                ${Object.keys(items)
                  .map((key) => `<li>${key || ''} : ${items[key]}</li>`)
                  .join('')}
              </ul>
          </div>
        `;
      })
      .join('');

    const checkLabsValue = (subject) => {
      const value = selectedSchoolData?.['Lab Facility Details']?.[subject] || '';
      return value.replace('(Fully Equipped)', '').trim() === 'Yes';
    };

    const facilityDetailsPayload = {
      schoolId: data?.id,
      facilityDetails,
      safetyDetails: null,
      selectedInfraList: [
        {
          id: 25,
          version: 1,
          deleted: false,
          active: true,
          name: 'Play Area',
          slug: 'play-area',
          description: null,
          iconId: null,
          infraType: {
            id: 19,
            version: 1,
            deleted: false,
            active: true,
            name: 'Sports',
            displayName: null,
            type: 3,
            description: null,
          },
          value: 25,
          label: 'Play Area',
        },
        {
          id: 42,
          version: 1,
          deleted: false,
          active: true,
          name: 'Library',
          slug: 'library',
          description: null,
          iconId: null,
          infraType: {
            id: 14,
            version: 1,
            deleted: false,
            active: true,
            name: 'Education',
            displayName: null,
            type: 3,
            description: null,
          },
          value: 42,
          label: 'Library',
        },
        ...[
          checkLabsValue('Physics') || checkLabsValue('Chemistry') || checkLabsValue('Biology')
            ? {
                id: 55,
                version: 1,
                deleted: false,
                active: true,
                name: 'Laboratories',
                slug: 'laboratories',
                description: null,
                iconId: null,
                infraType: {
                  id: 16,
                  version: 1,
                  deleted: false,
                  active: true,
                  name: 'Laboratories',
                  displayName: null,
                  type: 3,
                  description: null,
                },
                value: 55,
                label: 'Laboratories',
              }
            : {},
        ],
        ...[
          checkLabsValue('Language')
            ? {
                id: 56,
                version: 1,
                deleted: false,
                active: true,
                name: 'Language Labs',
                slug: 'language-labs',
                description: null,
                iconId: null,
                infraType: {
                  id: 16,
                  version: 1,
                  deleted: false,
                  active: true,
                  name: 'Laboratories',
                  displayName: null,
                  type: 3,
                  description: null,
                },
                value: 56,
                label: 'Language Labs',
              }
            : {},
        ],
        ...[
          checkLabsValue('Matematics')
            ? {
                id: 57,
                version: 1,
                deleted: false,
                active: true,
                name: 'Maths Labs',
                slug: 'maths-labs',
                description: null,
                iconId: null,
                infraType: {
                  id: 16,
                  version: 1,
                  deleted: false,
                  active: true,
                  name: 'Laboratories',
                  displayName: null,
                  type: 3,
                  description: null,
                },
                value: 57,
                label: 'Maths Labs',
              }
            : {},
        ],
        ...[
          checkLabsValue('Computer')
            ? {
                id: 59,
                version: 1,
                deleted: false,
                active: true,
                name: 'Computer Labs',
                slug: 'computer-labs',
                description: null,
                iconId: null,
                infraType: {
                  id: 16,
                  version: 1,
                  deleted: false,
                  active: true,
                  name: 'Laboratories',
                  displayName: null,
                  type: 3,
                  description: null,
                },
                value: 59,
                label: 'Computer Labs',
              }
            : {},
        ],
      ]?.filter((e) => !isEmpty(e)),
    };

    const facilityDetailsResponse = await api({
      method: 'POST',
      url: `${API_BASE_URL}/school/admin/edit/updateFacilityDetails`,
      data: facilityDetailsPayload,
    });

    // =============== System Info ===============
    const systemInfoPayload = {
      schoolId: data?.id,
      displayName: selectedSchoolDataObj?.school_name || data?.name,
      slug: data?.slug,
      searchName: '',
      active: false,
      claimed: false,
      showDetailedView: true,
      closed: false,
      claimedDate: null,
      systemInfo: {
        verified: false,
        notes: '',
        googleMapsUrl: '',
      },
      schoolIds: [
        {
          name: 'Edudel School ID',
          id: selectedSchoolData?.['schoolInfo']['School Id'] || '',
        },
        ...[
          selectedSchoolDataObj?.['UDISE Code']
            ? {
                name: 'UDISE Code',
                id: selectedSchoolDataObj?.['UDISE Code'] || '',
              }
            : {},
        ],
      ],
    };

    const systemInfoResponse = await api({
      method: 'POST',
      url: `${API_BASE_URL}/school/admin/edit/updateSystemInfo`,
      data: systemInfoPayload,
    });

    // =============== Academic Info ===============

    const levels = [];

    if (romanToInt(schoolDetails?.highestGrade) > 10) {
      levels.push({
        id: 'AISSCE',
        name: 'All India Senior School Certificate Examination (AISSCE) (12th)',
      });
      levels.push({
        id: 'AISSE',
        name: 'All India Secondary School Examination (AISSE) (10th)',
      });
    } else if (romanToInt(schoolDetails?.highestGrade) > 0) {
      levels.push({
        id: 'AISSE',
        name: 'All India Secondary School Examination (AISSE) (10th)',
      });
    }

    const seniorSecondaryStreams = [];
    const checkStreams = (sub) => {
      return selectedSchoolData?.['Stream Details']?.[sub]?.replace('(Fully Equipped)', '').trim() === 'Yes';
    };

    if (checkStreams('Science')) {
      seniorSecondaryStreams.push({
        name: 'Science with Mathematics',
      });
    }
    if (checkStreams('Commerce')) {
      seniorSecondaryStreams.push({
        name: 'Commerce',
      });
    }
    if (checkStreams('Arts')) {
      seniorSecondaryStreams.push({
        name: 'Humanities',
      });
    }
    if (checkStreams('Vocational')) {
      seniorSecondaryStreams.push({
        name: 'Vocational Courses',
      });
    }

    const academicInfoPayload = {
      schoolId: data?.id,
      academicInfo: {
        seniorSecondaryStreams,
        shift:
          selectedSchoolData?.['schoolInfo']?.['Shift']?.toLowerCase() === 'evening'
            ? SchoolShifts
            : SchoolShifts.filter((s) => s?.name === 'Shift 1 (Morning)'),
        schoolHours: [
          {
            board: 'All',
            level: 'All',
          },
        ],
        languages: [
          {
            id: 61,
            version: 1,
            deleted: false,
            active: true,
            name: 'English',
            displayName: null,
            type: 5,
            description: null,
            value: 61,
            label: 'English',
          },
        ],
        curriculumDetails: [
          {
            curriculum: 'CBSE',
            affiliationNumber: selectedSchoolDataObj?.cbse || '',
            affiliationStartDate: '',
            affiliationType: '',
            classes: [],
            levels,
          },
        ],
      },
      boards: [
        {
          subLevels: [
            {
              id: 'AISSCE',
              name: 'All India Senior School Certificate Examination (AISSCE) (12th)',
            },
            {
              id: 'AISSE',
              name: 'All India Secondary School Examination (AISSE) (10th)',
            },
          ],
          id: 1,
          version: 1,
          deleted: false,
          active: true,
          name: 'CBSE',
          displayName: 'Central Board of Secondary Education (CBSE)',
          slug: 'cbse',
          description: null,
          preschool: false,
          logoId: null,
        },
      ],
      schoolGroups: [
        {
          id: 14,
          version: 1,
          deleted: false,
          active: true,
          name: 'Delhi Government Schools',
          shortName: 'delgov',
          slug: 'delhi-government-schools',
          description: null,
          logoId: null,
          website: null,
          isAssociation: false,
          addToSitemap: true,
          value: 14,
          label: 'Delhi Government Schools',
        },
      ],
      schoolLevels: getSchoolLevelsList(data),
    };

    const academicInfoResponse = await api({
      method: 'POST',
      url: `${API_BASE_URL}/school/admin/edit/updateAcademicDetails`,
      data: academicInfoPayload,
    });

    setLoading(false);
    history.replace('/schools/list');
  };

  useEffect(() => {
    if (!isEmpty(schoolDetails)) {
      handleUpdateSchoolDetails(schoolDetails);
    }
  }, [schoolDetails]);

  // Bulk Upload JSON Files
  const [modalOpen, setModalOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  const [uploading, setUploading] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setFiles([]);
    setProgress({ current: 0, total: 0 });
    setUploading(false);
  };

  const handleModalAlert = () => {
    if (uploading) {
      alert('Please wait for the current upload to finish before closing the modal.');
      return;
    }

    toggleModal();
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files).filter((file) => file.name.endsWith('.json'));
    if (selectedFiles.length === 0) {
      alert('Please select valid JSON files.');
      return;
    }
    setFiles(selectedFiles);
    setProgress({ current: 0, total: selectedFiles.length });
  };

  const startUpload = async () => {
    if (files.length === 0) {
      alert('Please select files to upload.');
      return;
    }

    setUploading(true);
    files.forEach(async (file) => {
      await handleFileUpload(file, true);

      setProgress((prev) => ({
        ...prev,
        current: prev.current + 1,
      }));
    });
    setUploading(false);
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Loader isActive={addSchoolLoading || loading} />
          <Breadcrumbs title="Schools" breadcrumbItem="Add School Temp" />

          <Modal isOpen={modalOpen} toggle={handleModalAlert} centered>
            <ModalHeader toggle={handleModalAlert}>Bulk JSON Upload</ModalHeader>
            <ModalBody className="text-center p-5 bg-light">
              <Input type="file" multiple accept=".json" onChange={handleFileChange} disabled={uploading} />
              {progress.total > 0 && (
                <div className="border shadow-md rounded-3 p-4 mt-4 bg-white">
                  <p className="mt-3">
                    Completed {progress.current} of {progress.total}
                  </p>
                  <Progress value={(progress.current / progress.total) * 100 || 0} color="success" />
                </div>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={startUpload} disabled={uploading || files.length === 0}>
                {uploading ? 'Uploading...' : 'Start Upload'}
              </Button>
              <Button className="ms-2" color="light" onClick={toggleModal} disabled={uploading}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>

          <Form onSubmit={formik.handleSubmit}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center">
                <h3 className="mb-0">Basic Info</h3>
                <button className="btn btn-sm btn-success ms-3" type="button" onClick={toggleModal}>
                  Upload Bulk JSON
                </button>
              </div>

              <div className="d-flex align-items-center">
                <label className="mb-0 me-3">Upload JSON</label>
                <input type="file" accept=".json" onChange={handleFileUpload} />
              </div>
            </div>

            <Card className="mb-5">
              <CardBody>
                <Row>
                  <Col md={7}>
                    <FormGroup className="mb-4">
                      <Label for="schoolname" className="form-label  ">
                        School Name
                      </Label>
                      <Input
                        id="schoolname"
                        type="text"
                        className="form-control"
                        placeholder="School Name..."
                        label="School Name"
                        invalid={!!(formik.touched.name && formik.errors.name)}
                        {...formik.getFieldProps('name')}
                        error={!isEmpty(formik.errors.name)}
                      />
                      <FormFeedback className="d-block">{formik.errors.name}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={5}>
                    <FormGroup className="mb-4">
                      <Label for="school_shortname" className="form-label  ">
                        School Short Name
                      </Label>
                      <Input
                        id="school_shortname"
                        name="school_shortname"
                        type="text"
                        className="form-control"
                        placeholder="School Short Name..."
                        invalid={!!(formik.touched.shortName && formik.errors.shortName)}
                        {...formik.getFieldProps('shortName')}
                      />
                      <FormFeedback className="d-block">{formik.errors.shortName}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label for="establishedIn">Established In</Label>
                      <InputGroup id="establishedIn">
                        <DatePicker
                          selected={formik.values.establishedIn}
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholder="Established in..."
                          autoComplete="off"
                          minDate={moment('1200-01-01').toDate()}
                          maxDate={moment().toDate()}
                          onChange={(date) => {
                            formik.setFieldValue('establishedIn', date);
                          }}
                          invalid={!!(formik.touched.establishedIn && formik.errors.establishedIn)}
                        />
                      </InputGroup>
                      <FormFeedback className="d-block">{formik.errors.establishedIn}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label for="school_gender" className="form-label  ">
                        Student Gender Type
                      </Label>
                      <Select
                        id="school_gender"
                        placeholder="Please select an option"
                        options={studentGenderList}
                        value={formik.values.studentGender}
                        onChange={(val) => formik.setFieldValue('studentGender', val)}
                      />
                      <FormFeedback className="d-block">{formik.errors.studentGender}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <FormGroup className="mb-4">
                      <Label for="school_boarding" className="form-label">
                        Boarding Type
                      </Label>
                      <Select
                        id="school_boarding"
                        placeholder="Select an option"
                        options={schoolsMasterData.filter((d) => d.type === SchoolMasterType.BOARDING_TYPE)}
                        value={formik.values.boardingType}
                        onChange={(val) => formik.setFieldValue('boardingType', val)}
                      />
                      <FormFeedback className="d-block">{formik.errors.boardingType}</FormFeedback>
                    </FormGroup>
                  </Col>

                  {formik.values?.boardingType?.name?.includes('Boarding') && (
                    <>
                      <Col md={4}>
                        <FormGroup className="mb-4">
                          <Label for="school_sub_boarding" className="form-label  ">
                            Sub Boarding Type
                          </Label>
                          <Select
                            isMulti
                            id="school_sub_boarding"
                            placeholder="Select an option"
                            options={schoolsMasterData.filter((d) => d.type === SchoolMasterType.BOARDING_SUB_TYPE)}
                            value={formik.values.boardingSubTypes}
                            onChange={(val) => formik.setFieldValue('boardingSubTypes', val)}
                          />
                          <FormFeedback className="d-block">{formik.errors.boardingSubTypes}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup className="mb-4">
                          <Label for="school_boarding_gender_type" className="form-label  ">
                            Boarding Gender Type
                          </Label>
                          <Select
                            id="school_boarding_gender_type"
                            placeholder="Select an option"
                            options={schoolsMasterData.filter((d) => d.type === SchoolMasterType.BOARDING_GENDER_TYPE)}
                            value={formik.values.boardingGenderType}
                            onChange={(val) => formik.setFieldValue('boardingGenderType', val)}
                          />
                          <FormFeedback className="d-block">{formik.errors.boardingGenderType}</FormFeedback>
                        </FormGroup>
                      </Col>
                    </>
                  )}
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label for="school_manag_type" className="form-label  ">
                        Management Type
                      </Label>
                      <Select
                        id="school_manag_type"
                        placeholder="Select an option"
                        options={schoolsMasterData.filter((d) => d.type === SchoolMasterType.MANAGEMENT_TYPE)}
                        value={formik.values.managementType}
                        onChange={(val) => formik.setFieldValue('managementType', val)}
                      />
                      {formik.touched.managementType && (
                        <div className="invalid-feedback d-block">{formik.errors.managementType}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label for="school_manag_name" className="form-label  ">
                        Management Name/Trust/Society Name
                      </Label>
                      <Input
                        id="school_manag_name"
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        label="Established In"
                        invalid={!!(formik.touched.managementName && formik.errors.managementName)}
                        {...formik.getFieldProps('managementName')}
                      />
                      <FormFeedback className="d-block">{formik.errors.managementName}</FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup className="mb-4">
                      <CardTitle htmlFor="schooldesc" className="form-label mb-4">
                        School Shift
                      </CardTitle>
                      <Row>
                        {SchoolShifts.map((shift, i) => (
                          <Col key={`shift_${i}`} md={3}>
                            <ToggleButton
                              label={shift.name}
                              onChange={(e) => handleToggleShifts(e.target.checked, shift)}
                              checked={formik.values.schoolShift.some(
                                (s) => s.name.toLowerCase() === shift.name.toLowerCase()
                              )}
                            />
                          </Col>
                        ))}
                      </Row>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <h3 className="mb-4">Address</h3>
            <Card className="mb-5">
              <CardBody>
                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_country" className="form-label  ">
                        Country <span className="text-danger">*</span>
                      </Label>
                      <Select
                        id="school_country"
                        value={formik.values.country}
                        options={countries}
                        onChange={handleCountrySelect}
                      />
                      {formik.touched.country && (
                        <div className="invalid-feedback d-block">{formik.errors.country}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_region" className="form-label  ">
                        Region/State <span className="text-danger">*</span>
                      </Label>
                      <Select
                        id="school_region"
                        value={formik.values.region}
                        options={regions}
                        onChange={handleRegionSelect}
                      />
                      {formik.touched.region && <div className="invalid-feedback d-block">{formik.errors.region}</div>}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_district" className="form-label  ">
                        District
                      </Label>
                      <Select
                        isClearable
                        id="school_district"
                        value={formik.values.district}
                        // NOTE: cities and districts too
                        options={cities?.filter((c) => c.level === 2)}
                        onChange={handleDistrictSelect}
                      />
                      {formik.touched.district && (
                        <div className="invalid-feedback d-block">{formik.errors.district}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_city" className="form-label  ">
                        City <span className="text-danger">*</span>
                      </Label>
                      <Creatable
                        isClearable
                        id="school_city"
                        value={formik.values.city}
                        options={cities?.filter((c) => c.level === 3)}
                        onChange={handleCitySelect}
                      />
                      {formik.touched.city && <div className="invalid-feedback d-block">{formik.errors.city}</div>}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_subarea" className="form-label  ">
                        SubArea
                      </Label>
                      <Creatable
                        isClearable
                        id="school_subarea"
                        value={formik.values.subArea}
                        options={subAreas}
                        onChange={handleSubAreaSelect}
                      />
                      {formik.touched.subArea && (
                        <div className="invalid-feedback d-block">{formik.errors.subArea}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_pincode" className="form-label  ">
                        Pincode
                      </Label>
                      <Input
                        id="school_pincode"
                        type="text"
                        className="form-control"
                        placeholder="Pincode..."
                        invalid={!!(formik.touched.postalCode && formik.errors.postalCode)}
                        {...formik.getFieldProps('postalCode')}
                      />
                      <FormFeedback className="d-block">{formik.errors.postalCode}</FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_address" className="form-label  ">
                        Address
                      </Label>
                      <Input
                        id="school_address"
                        type="textarea"
                        className="form-control"
                        rows="3"
                        placeholder="Address..."
                        invalid={!!(formik.touched.fullAddress && formik.errors.fullAddress)}
                        {...formik.getFieldProps('fullAddress')}
                      />
                      <FormFeedback className="d-block">{formik.errors.fullAddress}</FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="latitude" className="form-label  ">
                        Latitude
                      </Label>
                      <Input
                        id="latitude"
                        type="text"
                        className="form-control mb-1"
                        placeholder="Latitude..."
                        invalid={!!(formik.touched.latitude && formik.errors.latitude)}
                        {...formik.getFieldProps('latitude')}
                      />
                      Ref: 20.12345678
                      <FormFeedback className="d-block">{formik.errors.latitude}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="longitude" className="form-label  ">
                        Longitude
                      </Label>
                      <Input
                        id="longitude"
                        type="text"
                        className="form-control mb-1"
                        placeholder="Longitude..."
                        invalid={!!(formik.touched.longitude && formik.errors.longitude)}
                        {...formik.getFieldProps('longitude')}
                      />
                      Ref: 20.12345678
                      <FormFeedback className="d-block">{formik.errors.longitude}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <h3 className="mb-4">Contact Details</h3>
            <Card className="mb-5">
              <CardBody>
                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="phoneLandline" className="form-label  ">
                        Phone (Landline)
                      </Label>
                      <PhoneInput
                        disableSearchIcon
                        specialLabel=""
                        country="in"
                        inputClass="phoneInput"
                        buttonClass="phoneButton"
                        enableSearch
                        placeholder="Phone (Landline)..."
                        value={formik.values.phoneLandline}
                        onChange={(phone) => formik.setFieldValue('phoneLandline', phone)}
                      />
                      <FormFeedback className="d-block">{formik.errors.phoneLandline}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="phoneMobile" className="form-label  ">
                        Phone (Mobile)
                      </Label>
                      <PhoneInput
                        disableSearchIcon
                        specialLabel=""
                        country="in"
                        inputClass="phoneInput"
                        buttonClass="phoneButton"
                        enableSearch
                        placeholder="Phone (Mobile)..."
                        value={formik.values.phoneMobile}
                        onChange={(phone) => formik.setFieldValue('phoneMobile', phone)}
                      />
                      <FormFeedback className="d-block">{formik.errors.phoneMobile}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="emailInfo" className="form-label  ">
                        Email (Info)
                      </Label>
                      <Input
                        id="emailInfo"
                        type="text"
                        className="form-control"
                        placeholder="Email (Info)..."
                        invalid={!!(formik.touched.emailInfo && formik.errors.emailInfo)}
                        {...formik.getFieldProps('emailInfo')}
                      />
                      <FormFeedback className="d-block">{formik.errors.emailInfo}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="emailAdmission" className="form-label  ">
                        Email (Admission)
                      </Label>
                      <Input
                        id="emailAdmission"
                        type="text"
                        className="form-control"
                        placeholder="Email (Admission)..."
                        invalid={!!(formik.touched.emailAdmission && formik.errors.emailAdmission)}
                        {...formik.getFieldProps('emailAdmission')}
                      />
                      <FormFeedback className="d-block">{formik.errors.emailAdmission}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="website" className="form-label  ">
                        Website
                      </Label>
                      <Input
                        id="website"
                        type="text"
                        className="form-control"
                        placeholder="Website..."
                        invalid={!!(formik.touched.website && formik.errors.website)}
                        {...formik.getFieldProps('website')}
                      />
                      <FormFeedback className="d-block">{formik.errors.website}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <h3 className="mb-4">Curriculum</h3>
            <Card className="mb-5">
              <CardBody className="my-3">
                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_acad_year" className="form-label">
                        Academic Year
                      </Label>
                      <Input
                        id="school_acad_year"
                        type="text"
                        className="form-control"
                        rows="3"
                        placeholder=""
                        invalid={!!(formik.touched.academicYear && formik.errors.academicYear)}
                        {...formik.getFieldProps('academicYear')}
                      />
                      <FormFeedback className="d-block">{formik.errors.academicYear}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-4">
                      <Label htmlFor="school_acad_period" className="form-label  ">
                        Admission Period
                      </Label>
                      <Input
                        id="school_acad_period"
                        type="text"
                        className="form-control"
                        rows="3"
                        placeholder=""
                        invalid={!!(formik.touched.admissionPeriod && formik.errors.admissionPeriod)}
                        {...formik.getFieldProps('admissionPeriod')}
                      />
                      <FormFeedback className="d-block">{formik.errors.admissionPeriod}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4}>
                    <FormGroup className="mb-4">
                      <Label for="school_manag_type" className="form-label  ">
                        Curriculum Boards
                      </Label>

                      <Select
                        isMulti
                        id="school_manag_type"
                        placeholder="Select an option"
                        options={schoolBoardsSelect}
                        value={formik.values.curriculumBoards}
                        onChange={(val) => formik.setFieldValue('curriculumBoards', val)}
                      />
                      <FormFeedback className="d-block">{formik.errors.curriculumBoards}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup className="mb-4">
                      <Label for="lowestgrade" className="form-label  ">
                        Lowest grade
                      </Label>

                      <Select
                        id="lowestgrade"
                        placeholder="Select an option"
                        options={gradeSelectArray?.map((e) => ({
                          ...e,
                          label: e?.name,
                          value: e?.name,
                        }))}
                        value={formik.values.lowestgrade}
                        onChange={(val) => formik.setFieldValue('lowestgrade', val)}
                      />
                      <FormFeedback className="d-block">{formik.errors.lowestgrade}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup className="mb-4">
                      <Label for="highestgrade" className="form-label  ">
                        Highest grade
                      </Label>

                      <Select
                        id="highestgrade"
                        placeholder="Select an option"
                        options={gradeSelectArray?.map((e) => ({
                          ...e,
                          label: e?.name,
                          value: e?.name,
                        }))}
                        value={formik.values.highestgrade}
                        onChange={(val) => {
                          formik.setFieldValue('highestgrade', val);
                          setGradeError('');
                        }}
                      />

                      {!isEmpty(gradeError) && <p className="text-start text-danger mt-2">{gradeError}</p>}
                      <FormFeedback className="d-block">{formik.errors.highestgrade}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <div className="mb-5 pb-5">
              <div className="pb-4 pt-3 text-end ">
                <Button type="submit" color="primary">
                  Submit School
                </Button>
                <Button
                  color="light"
                  className="ms-4 px-3"
                  onClick={() => {
                    history.replace(SMKLinks.SCHOOL_LISTING);
                  }}>
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default AddSchoolTemp;
